// extracted by mini-css-extract-plugin
export var arrow = "component-module--arrow--596c5";
export var cards = "component-module--cards--ec0ed";
export var cardsTrack = "component-module--cardsTrack--b9f6b";
export var cardsWrapper = "component-module--cardsWrapper--e6811";
export var dots = "component-module--dots--aa5f4";
export var main = "component-module--main--b7e25";